import Button from "@components/Button";
import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import { utils } from "@playroomkit/pr-wars/utils";
import { Bot, useBots } from "@src/contexts/BotsProvider";
import { useUrlMapper } from "@src/contexts/URLMapperContext";
import { useManager } from "@src/contexts/WarsContext";
import { images } from "@utils/media";

function getRandomBots(bots: Bot[]) {
  const availableBots = bots.filter((bot) => bot.enabled);
  return utils.shuffle([...availableBots]).slice(0, 3);
}

const AddPlayersPopup = (props: { closePopup: () => void }) => {
  const { closePopup } = props;

  const { bots } = useBots();
  const manager = useManager();
  const urlMapper = useUrlMapper();
  const unselectedBots = getRandomBots(bots);

  const addBots = () => {
    unselectedBots.map((bot) => manager.addBot(bot.id));
    closePopup();
  };

  const inviteMoreFriends = async () => {
    await manager.invitePlayersOnDiscord();
  };

  return (
    <View className="w-screen h-dvh absolute top-0 left-0 z-[999999] font-[Slackey]">
      <View
        enableEventCapturing
        className="w-full h-full absolute top-0 left-0 bg-black/60"
      />
      <ScalableWrapper maintainAspectRatioBy="height">
        <View className="w-full h-full flex items-center justify-center">
          <View
            enableEventCapturing
            className="relative bg-[#F72EC5] w-[40rem] p-1.5 rounded-xl flex flex-col items-center"
          >
            <Button
              className="bg-transparent border-none outline-none absolute -top-4 -right-4"
              onClick={closePopup}
            >
              <img
                src={images.ClosePopupIcon}
                alt="close-popup"
                className="w-8 h-8 object-contain"
              />
            </Button>
            <h1
              className="text-white mt-0.5 mb-2"
              style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
            >
              Invite Players!
            </h1>
            <View className="w-full h-80 bg-gradient-to-t from-[#3355FF] to-[#5B7CFF] rounded-b-xl overflow-hidden">
              <View
                className="w-full h-full bg-cover bg-no-repeat flex flex-col items-center justify-center gap-4"
                style={{ backgroundImage: `url(${images.TilesBackground})` }}
              >
                <View className="w-full h-52 flex justify-center gap-4">
                  {unselectedBots.map((bot, index) => {
                    return (
                      <View
                        key={index}
                        style={{
                          backgroundImage: `url(${images.BotSelectionCard})`,
                        }}
                        className="relative w-40 h-auto bg-contain bg-no-repeat flex flex-col items-center"
                      >
                        <img
                          src={urlMapper.mapUrl(bot.modelImageUrl)}
                          alt="bot-image"
                          className="w-full h-full object-contain translate-y-3"
                        />
                        <View className="absolute bottom-0 w-full flex justify-center px-4">
                          <p
                            className="text-xl text-[#FFF4D0] text-center leading-none"
                            style={{
                              textShadow: "0px 2.24px 0px rgba(0, 0, 0, 0.5)",
                            }}
                          >
                            {bot?.name}
                          </p>
                        </View>
                      </View>
                    );
                  })}
                </View>
                <View className="flex gap-3">
                  <View
                    style={{
                      backgroundImage: `url(${images.InviteFriendsButtonImage})`,
                    }}
                    className="w-44 h-16 bg-contain bg-no-repeat"
                  >
                    <Button className="bg-transparent border-none outline-none w-full h-full" onClick={inviteMoreFriends} />
                  </View>
                  <View
                    style={{
                      backgroundImage: `url(${images.AddAIPlayersButtonImage})`,
                    }}
                    className="w-80 h-16 bg-contain bg-no-repeat"
                  >
                    <Button
                      className="bg-transparent border-none outline-none w-full h-full"
                      onClick={addBots}
                    />
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
      </ScalableWrapper>
    </View>
  );
};

export default AddPlayersPopup;
